'use client';

import { SITE_URL } from '../../common/constant';
import { useTranslations } from 'next-intl';

export const OrganizationSEO = () => {
  const t = useTranslations();
  const businessData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: `TRT ${t('trt-channel')}`,
    url: SITE_URL,
    logo: `${SITE_URL}/svg/main-logo.svg`,
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+90-212-326-3000',
      contactType: 'customer service',
      areaServed: 'TR',
      availableLanguage: ['Turkish', 'English'],
    },
    sameAs: [
      'https://www.instagram.com/trtworld',
      'https://www.tiktok.com/trtworld',
      'https://www.youtube.com/channel/UC7fWeaHhqgM4Ry-RMpM2YYw',
      'https://www.twitter.com/trtworld',
      'https://www.facebook.com/trtworld',
      'https://www.snapchat.com/trtworld',
    ],
  };

  const localBusinessData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: `TRT ${t('trt-channel')} Headquarters`,
    image: 'https://www.yourwebsite.com/logo.png',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ahmet Adnan Saygun Street No:83',
      addressLocality: 'Ulus, Besiktas',
      postalCode: '34347',
      addressRegion: 'İstanbul',
      addressCountry: 'TR',
    },
    telephone: '+90-212-403-4600',
    openingHours: 'Mo-Fr 09:00-17:00',
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 41.0766,
      longitude: 29.0203,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(businessData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessData) }}
      />
    </>
  );
};
